import './App.css';
import logo from './logo.jpg';
import zkUrl from './image/zk.png';
// import { OverPack } from 'rc-scroll-anim';
// import QueueAnim from 'rc-queue-anim';
import { useEffect, useState } from 'react';
import Timeline from './Timeline';

function App() {
  const [active, setActive] = useState(1);
  const [click, setClick] = useState(false);
  const [scroll, setScroll] = useState(false);
  const [zk, setZk] = useState(false);

  // animate
  useEffect(() => {
    document.addEventListener('scroll', () => setScroll(true));
  }, []);
  useEffect(() => {
    if (click || !scroll) {
      setScroll(false);
      return;
    }
    const currentScroll = document.documentElement.scrollTop;
    const h2 = document.getElementById('section2')?.offsetTop || 0;
    const h3 = document.getElementById('section3')?.offsetTop || 0;
    const h4 = document.getElementById('section4')?.offsetTop || 0;
    const h5 = document.getElementById('section5')?.offsetTop || 0;
    if (currentScroll < h2) {
      setActive(1);
      setScroll(false);
      return;
    }
    if (currentScroll < h3) {
      setActive(2);
      setScroll(false);
      return;
    }
    if (currentScroll < h4) {
      setActive(3);
      setScroll(false);
      return;
    }
    if (currentScroll < h5) {
      setActive(4);
      setScroll(false);
      return;
    }
    setActive(5);
    setScroll(false);
  }, [click, scroll]);
  useEffect(() => {
    if (!click || scroll) {
      setClick(false);
      return;
    }
    switch (active) {
      case 1:
        document.getElementById('section1')?.scrollIntoView();
        break;
      case 2:
        document.getElementById('section2')?.scrollIntoView();
        break;
      case 3:
        document.getElementById('section3')?.scrollIntoView();
        break;
      case 4:
        document.getElementById('section4')?.scrollIntoView();
        break;
      case 5:
        document.getElementById('section5')?.scrollIntoView();
        break;
    }
    setTimeout(() => {
      setClick(false)
    }, 900)
  }, [active]);

  return (
    <>
      <header className="header">
        <div className='leftBox'>
          <a href="#">
            <img className='logo' src={logo} />
          </a>
          <div className='divider'></div>
          <div>
            <p>
              <a href="https://www.ucc.ie/en/compsci/">SCHOOL OF COMPUTER SCIENCE AND INFORMATION TECHNOLOGY</a>
            </p>
            <p>
              <a href="https://www.ucc.ie/en/">UNIVERSITY COLLEGE CORK</a>
            </p>
          </div>
        </div>
        <img className='zk' onClick={() => setZk(z => !z)} src={zkUrl} />
        <nav className={`nav ${zk ? 'zknav' : 'bzknav'}`} >
          <p className={active === 1 ? 'active' : ''} onClick={() => {
            setActive(1)
            setClick(true)
            setZk(false)
          }}>INFORMATION</p>
          <p className={active === 2 ? 'active' : ''} onClick={() => {
            setActive(2)
            setClick(true)
            setZk(false)
          }}>DATES</p>
          <p className={active === 3 ? 'active' : ''} onClick={() => {
            setActive(3)
            setClick(true)
            setZk(false)
          }}>SUBMIT</p>
          <p className={active === 4 ? 'active' : ''} onClick={() => {
            setActive(4)
            setClick(true)
            setZk(false)
          }}>ARCHIVE</p>
          <p className={active === 5 ? 'active' : ''} onClick={() => {
            setActive(5)
            setClick(true)
            setZk(false)
          }}>CONTACT</p>
        </nav>
      </header>
      <section className='bannerbox'>
        <h1>Welcome to AIPO Competition</h1>
        <p> <a href="./pdf/AIPO_2026_Prelim.pdf">2026 AIPO Preliminary Round Problems</a> have been released.</p>
        <p>The submission <span style={{ color: "#ffd452" }}>deadline</span> for the preliminary round problems is <span style={{ color: "#ffd452" }}>15th February 2026</span></p>
        <p>Also available are some <a href="./pdf/AIPO_Tips___Tricks.pdf" style={{ color: "#ffd452" }}>tips</a> for solving problems and submitting to the server</p>
      </section>
      <div className='content-box'>
        <section className='page1' id="section1">
          <div className='common-box'>
            <h1 className='marginSmall'>General Information</h1>
            <h2>An annual computer programming olympiad held at University College Cork (UCC).</h2>
            {/* on the 1st of July */}
            <p>The All Ireland Programming Olympiad(AIPO) Competition is open to all second-level students in Ireland who are under 20. AIPO aims to achieve the following:</p>
            <p style={{ paddingTop: "14px", margin: 0, fontWeight: 500 }}>AIPO aims to achieve the following:</p>
            <ol className='textUl'>
              <li>To promote contacts among programmers in Ireland.</li>
              <li>To encourage and reward young programmers, (male and female).</li>
              <li>To select a team for the International Olympiad in Informatics (IOI) and for the European Computer Science Olympiad for Girls.</li>
            </ol>
            <p style={{ paddingTop: "14px", margin: 0, fontWeight: 500 }}>It consists of two rounds: </p>
            <ol className='textUl'>
              <li>The First Round can be done at home or at school and is used to determine the entry to the final round, which will be held in the School of Computer Science and Information Technology at UCC. </li>
              <li>The AIPO Final Round will take in person on the <span style={{ color: "#1aab91" }}>7th March 2026</span> in UCC.</li>
            </ol>
          </div>
        </section>
        <section className='page1 page2' id="section2">
          <div className='common-box'>
            <h1 className='marginSmall'>AIPO Important Dates</h1>
            <h2>The keys dates for the 2026 AIPO Olympiad</h2>
            <Timeline data={[
              { time: '15th of January 2026', value: 'Preliminary round problems released. Registration for AIPO 2026.' },
              { time: '15th of February 2026', value: 'Deadline for the preliminary round problems.' },
              { time: '16th of February 2026', value: 'Preliminary round competition released.' },
              { time: '21st of February 2026', value: 'Mock competition as preparation for the AIPO final.' },
              { time: '7th March 2026', value: 'AIPO final and selection for extended Irish panels.' },
              { time: 'To be determined.', value: 'Three training days in UCC to select EGOI and IOI teams.' },
              { time: '12th-18th May 2026', value: 'EGOI, Cesenatico, Italy' },
              { time: 'To be determined.', value: 'Training days in UCC as preparation for the IOI.' },
              { time: '9th-16th August 2026', value: 'IOI, Tashkent, Uzbekistan' },
            ]} />
          </div>
        </section>
        <section className='page1' id="section3">
          <div className='common-box'>
            <h1>How to Submit</h1>
            <h2>Submitting Solutions</h2>
            <p>First, head to <a href='https://docs.google.com/forms/d/e/1FAIpQLSfMVYPpTvjTBsDnH1goUzwRAEgo_mxQAOxUmZggKYh7Ltbf9A/viewform?usp=publish-editor' style={{ color: "#1aab91" }}>this Google Form</a> and sign up by providing all requested information. Make sure you fill out both the registration Google form, as well as the server credential registration page (link at the top of the form). Once you have registered, you can use the credentials you created on the server to login to the server and begin making submissions.</p>
            <p>Each of the 5 problems has an entry on the right. Click the "Submissions" link below the appropriate question to get to the question page. From here, you can upload your solution and have it evaluated by the server. Within a minute, you should get a score from the system; each passed test case gets you 10 points, and the test cases are progressively harder.</p>
            <p>You can submit solutions as many times as you like, but only the most recently submitted solution will count towards your final score.</p>
            <p>The registration is functional from <span style={{ color: "#1aab91" }}>Sunday, 11th January 2026</span>. The submission is functional from <span style={{ color: "#1aab91" }}>Thursday, 15th January 2026.</span></p>
            <p>If you have any problems logging in, forgotten usernames or passwords, or with the system in general, please contact Andrew Nash <a type='email' href='mailto:anash@umail.ucc.ie'>anash@umail.ucc.ie</a></p >
          </div>
        </section>
        <section className='page1 page2' id="section4">
          <div className='common-box'>
            <h1>AIPO Archive</h1>
            <h2>Previous Problems</h2>
            <div className='columns2Box'>
              <ul className='columns2'>
                <li>
                  <a href="./pdf/IrlCPC_Problems_2025.pdf">2025 AIPO National Finals Problems</a>
                  <a href="./pdf/AIPO2025_Prelim.pdf">2025 AIPO Preliminary Round Problems</a>
                  <div className='clear'></div>
                </li>
                <li>
                  <a href="./pdf/AIPO_2024_Final.pdf">2024 AIPO National Finals Problems</a>
                  <a href="./pdf/AIPO2024_Prelim.pdf">2024 AIPO Preliminary Round Problems</a>
                  <div className='clear'></div>
                </li>
                <li>
                  <a href="./pdf/AIPO_2023.pdf">2023 AIPO National Finals Problems</a>
                  <a href="./pdf/AIPO2023_Prelim.pdf">2023 AIPO Preliminary Round Problems</a>
                  <div className='clear'></div>
                </li>
                <li>
                  <a href="./pdf/AIPO2022_Finals.pdf">2022 AIPO National Finals Problems</a>
                  <a href="./pdf/AIPO2022_Prelim.pdf">2022 AIPO Preliminary Round Problems</a>
                  <div className='clear'></div>
                </li>
                <li>
                  <a href="./pdf/AIPO2021_Finals.pdf">2021 AIPO National Finals Problems</a>
                  <a href="./pdf/AIPO2021_Prelim.pdf">2021 AIPO Preliminary Round Problems</a>
                  <div className='clear'></div>
                </li>
                <li>
                  <a href="./pdf/AIPO2020_Finals.pdf">2020 AIPO National Finals Problems</a>
                  <a href=""> </a>
                  <div className='clear'></div>
                </li>
                <li>
                  <a href="./pdf/AIPO2018_Finals.pdf">2018 AIPO National Finals Problems</a>
                  <a href="./pdf/AIPO2018_Prelim.pdf">2018 AIPO Preliminary Round Problems</a>
                  <div className='clear'></div>
                </li>
                <li>
                  <a href="./pdf/AIPO2017_Finals.pdf">2017 AIPO National Finals Problems</a>
                  <a href="./pdf/AIPO2017_Prelim.pdf">2017 AIPO Preliminary Round Problems</a>
                  <div className='clear'></div>
                </li>
                <li>
                  <a href="./pdf/AIPO2016_Finals.pdf">2016 AIPO National Finals Problems</a>
                  <a href="./pdf/AIPO2016_Prelim.pdf">2016 AIPO Preliminary Round Problems</a>
                  <div className='clear'></div>
                </li>
                <li>
                  <a href="./pdf/AIPO2015_Finals.pdf">2015 AIPO National Finals Problems</a>
                  <a href="./pdf/AIPO2015_Prelim.pdf">2015 AIPO Preliminary Round Problems</a>
                  <div className='clear'></div>
                </li>
                <li>
                  <a href="./pdf/AIPO2014_Finals.pdf">2014 AIPO National Finals Problems</a>
                  <a href="./pdf/AIPO2014_Prelim.pdf">2014 AIPO Preliminary Round Problems</a>
                  <div className='clear'></div>
                </li>
                <li>
                  <a href="./pdf/AIPO2013_Finals.pdf">2013 AIPO National Finals Problems</a>
                  <a href="./pdf/AIPO2013_Prelim.pdf">2013 AIPO Preliminary Round Problems</a>
                  <div className='clear'></div>
                </li>
              </ul>
            </div>
          </div>
        </section>
        <section className='page1' id="section5">
          <div className='common-box'>
            <h1>Contact Details</h1>
            <h2>You can contact the AIPO team</h2>
            <ol className='olmedia'>
              <li>Prof. Dirk Pesch, Head of School of CSIT, UCC<span>Chairperson</span></li>
              <li>Dr. Sabin Tabirca, UCC<span><a type='email' href='mailto:tabirca@cs.ucc.ie'>tabirca@cs.ucc.ie</a></span><span>Coordinator - General Questions</span></li>
              <li>Andrew Nash, UCC<span><a type='email' href='mailto:anash@umail.ucc.ie'>anash@umail.ucc.ie</a></span><span>Member - Registration, Submission and Server Questions</span></li>
              <li>Isabel Ronan, UCC<span><a type='email' href='mailto:i.ronan@cs.ucc.ie'>i.ronan@cs.ucc.ie</a></span><span>Member - AIPO Webpage Questions</span></li>
            </ol>
          </div>
        </section>
      </div>
      <footer className='footer'>
        © {new Date().getFullYear()}. All Ireland Programming Olympiad.
      </footer>
    </>
  );
}

export default App;
